import { Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Input, Select } from "../../../controls";
import { Form } from "../../../layout";
import { Model, UseForm } from "../../../hooks";
import { connect } from "react-redux";
import * as actions from "../../../api/actions/pos";
import { endpoints } from "../../../api/actions/api";
import { MaxLength, RmvEmptyProp, ToFormData } from "../../../hooks/Method";

//AddEditBills is the expense add/edit form.
const AddEditBills = (props) => {
  const { t } = useTranslation();    
  const { updData, setShowForm, _post, _put, _get, _authUser, _store } = props;
  const { ExpsMdl } = Model();
  const [expenseCats, setExpenseCats] = useState([]);

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
  } = UseForm(ExpsMdl);

  const validateForm = () => {
    let temp = {};
    temp.expenseCatId =
      values.expenseCatId !== ""
        ? ""
        : t("payTypeRequired");

    temp.amount =
      values.amount !== ""
        ? ""
        : t("totalRequired");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      values.userId = _authUser.id;
      const onComplete = () => {
        setShowForm(false);
      };
      if (updData === undefined) {
        values.storeId = _store.id;
        _post(
          endpoints.Expense,
          ToFormData(RmvEmptyProp(values)),
          actions.ActionType.AddItem,
          onComplete
        );
      } else if (updData !== undefined && updData.id !== undefined) {
        _put(
          endpoints.Expense,
          ToFormData(RmvEmptyProp(values)),
          actions.ActionType.UpdateItem,
          onComplete
        );
      }
    }
  };

  useEffect(() => {
    // Set Expense Category
    const onComplete = (res) => {
      res.status === 200 &&
        res.result.length > 0 &&
        setExpenseCats(
          res.result
            .sort((f, s) => f.id - s.id)
            .map((j) => {
              return {
                id: j.id,
                name: j.name,
              };
            })
        );
    };
    _get(endpoints.ExpenseCat, null, onComplete);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTimeout(() => {
      updData && setValues(updData);
    }, 300);
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updData]);

  return (
    <Form noValidate onSubmit={handleSubmit}>
      <Grid container spacing={3} className="p-20 pt-40">
        <Grid item xs={12} className="tx-center">
          <Typography variant="h5" className="fs-22 gray-color fw-5 tx-upp">
            {updData === undefined ? t("addBill") : t("updateBill")}
          </Typography>
          <div className="bs-bottom mx-w-60 m-auto mb-20" />
        </Grid>
        <Grid item xs={12}>
          <Select
            label={t("payType")}
            name="expenseCatId"
            value={values.expenseCatId}
            error={errors.expenseCatId}
            onChange={handleInpChg}
            options={expenseCats}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            label={t("total")}
            name="amount"
            type="number"
            onInput={(e) => (e.target.value = MaxLength(e.target.value, 9))}
            value={values.amount}
            error={errors.amount}
            onChange={handleInpChg}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            label={t("note")}
            multiline
            rows={3}
            name="note"
            inputProps={{ maxLength: 400 }}
            value={values.note}
            error={errors.note}
            onChange={handleInpChg}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          className="tx-right d-flex mt-20"
          sx={{ flexWrap: { xs: "wrap", md: "initial" } }}
        >
          <Button type="submit" className="btn-primary w-100pr" size="large">
            {updData === undefined ? t("submit") : t("saveChanges")}
          </Button>
          <Button
            onClick={() => setShowForm(false)}
            className="btn-error w-100pr"
            size="large"
            sx={{ ml: { md: "10px" }, mt: { xs: "15px", md: "0px" } }}
          >
            {t("close")}
          </Button>
        </Grid>
      </Grid>
    </Form>
  );
};

const mapStateToProps = (state) => ({
  _list: state.pos.list,
  _authUser: state.pos.authUser,
  _store: state.pos.defStore,
});

const mapActionToProps = {
  _post: actions.post,
  _put: actions.put,
  _get: actions.get,
};

export default connect(mapStateToProps, mapActionToProps)(AddEditBills);
